import {
	Component, Input, Output, OnChanges, SimpleChanges,
	SimpleChange, EventEmitter, OnInit, HostListener
} from '@angular/core';


@Component({
    selector: 'info',
	templateUrl: './info.component.html',
	styleUrls: ['./info.component.scss']
})
export class InfoComponent {

	@Input()
	public width: string;

	constructor() {
		this.width = "500px";
	}

}
